// Returns today's date as ISO (YYYY-MM-DD) and forces a re-render at midnight.
// Handles three cases:
//  1. Live: scheduled setTimeout that fires exactly at 00:00:01 tomorrow.
//  2. Backgrounded: window focus / visibilitychange re-check (device may have slept through midnight).
//  3. Clock/tz change: same handlers pick it up.
import { useEffect, useState } from "react";

function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default function useTodayISO() {
  const [iso, setIso] = useState(todayISO);

  useEffect(() => {
    let timer;
    const schedule = () => {
      const now = new Date();
      const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);
      const ms = Math.max(1000, next.getTime() - now.getTime());
      timer = setTimeout(() => {
        setIso(todayISO());
        schedule();
      }, ms);
    };
    schedule();

    const recheck = () => {
      const fresh = todayISO();
      setIso((prev) => (prev === fresh ? prev : fresh));
      clearTimeout(timer);
      schedule();
    };
    window.addEventListener("focus", recheck);
    document.addEventListener("visibilitychange", recheck);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("focus", recheck);
      document.removeEventListener("visibilitychange", recheck);
    };
  }, []);

  return iso;
}
